/**
 *
 * Asynchronously loads the component for
 * Author: TruongTX
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
